<template>
  <div>
    <div class="field is-grouped">
      <div class="control">
        <label class="checkbox">
          <input type="checkbox" :value="2019" v-model="selectedYears">
          2019
        </label>
      </div>
      <div class="control">
        <label class="checkbox">
          <input type="checkbox" :value="2018" v-model="selectedYears">
          2018
        </label>
      </div>
    </div>

    <line-chart
      :width="300"
      :height="100"
      :labels="['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']"
      :datasets="displayedDatasets"
      :options="$options.options"
    ></line-chart>
  </div>
</template>

<script>
import numeral from 'numeral';
import LineChart from './LineChart';

const datasets = {
  2019: {
    label: '2019 Casos',
    borderColor: 'rgba(50, 115, 220, 0.5)',
    backgroundColor: 'rgba(50, 115, 220, 0.1)',
    data: [8, 12, 15, 13, 20, 20, 15, 8, 0, 0, 0, 0]
  },
  2018: {
    label: '2018 Casos',
    borderColor: 'rgba(255, 56, 96, 0.5)',
    backgroundColor: 'rgba(255, 56, 96, 0.1)',
    data: [0, 0, 0, 0, 0, 0, 0, 5, 6, 15, 14, 5]
  }
};

const options = {
  scales: {
    yAxes: [{
      ticks: {
        beginAtZero: true,
        callback: value => numeral(value).format('0,0')
      }
    }]
  },
  tooltips: {
    mode: 'index',
    callbacks: {
      label(tooltipItem, data) {
        const label = data.datasets[tooltipItem.datasetIndex].label;
        const value = numeral(tooltipItem.yLabel).format('0,0');

        return `${label}: ${value}`;
      }
    }
  }
};

export default {
  name: 'monthly-sat-chart',
  datasets,
  options,
  components: {
    LineChart
  },
  data() {
    return {
      selectedYears: [2019, 2018]
    };
  },
  computed: {
    displayedDatasets() {
      return this.selectedYears.map(year => datasets[year]);
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/charts/MonthlySatChart.vue